import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Typography, Alert } from '@mui/material'
import SideBar from '../components/layout/SideBar'
import Footer from '../components/Footer'
import TopAssociates from '../components/dashboard/TopAssociates'
import StackedBarChart from '../components/dashboard/StackedBarChart'
import DonutChart from '../components/dashboard/DonutChart'
import { ReactComponent as ActiveAssociate } from '../assets/activeAssociateIcon.svg'
import { ReactComponent as InActiveAssociate } from '../assets/inActiveAssociateIcon.svg'
import {
  fetchAssociateDashboard,
  fetchAssociatesByMonth,
  fetchAssociatesByGrade,
} from '../slices/dashboardSlice'

const AdminDashboardScreen = () => {
  const dispatch = useDispatch()

  const {
    activeCount,
    inactiveCount,
    associatesByMonth,
    associatesByGrade,
    totalAssociateCount,
    error,
  } = useSelector((state) => state.dashboard)

  useEffect(() => {
    dispatch(fetchAssociateDashboard())
    dispatch(fetchAssociatesByMonth())
    dispatch(fetchAssociatesByGrade())
  }, [dispatch])

  return (
    // parent box
    <Box display='flex' height='100vh'>
      <SideBar />
      <Box
        flexGrow={1}
        display='flex'
        flexDirection='column'
        width='100%'
        paddingTop='74px'
        margin='1px 20px 0px 10px'>
        {/* Error Message */}
        {error && (
          <Alert severity='error' sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        {/* box 1 */}
        <Box
          flex='0 0 15%'
          display='flex'
          justifyContent='center'
          alignItems='center'
          height='14vh'
          marginBottom='clamp(15px, 0.5vw, 16px)'>
          {/* box1 left box  */}
          <Box
            backgroundColor='#F6FAFF'
            display='flex'
            flexDirection='row'
            paddingTop='24px'
            paddingBottom='6px'
            paddingLeft='18px'
            paddingRight='19px'
            marginRight='12px'
            borderRadius='20px'>
            <ActiveAssociate style={{ height: '72px' }} />
            <Box
              marginLeft='54px'
              display='flex'
              flexDirection='column'
              justifyContent='space-between'
              alignItems='flex-end'>
              <Typography
                variant='body1'
                color='primary'
                fontSize='22px'
                fontWeight='600'
                line-height='25px'>
                {activeCount}
              </Typography>
              <Typography variant='body1' color='black' fontSize='22px'>
                Active Associates
              </Typography>
            </Box>
          </Box>
          {/* box 1 right box  */}
          <Box
            backgroundColor='#F6FAFF'
            display='flex'
            flexDirection='row'
            paddingTop='24px'
            paddingBottom='6px'
            paddingLeft='18px'
            paddingRight='4px'
            borderRadius='20px'>
            <InActiveAssociate style={{ height: '72px' }} />
            <Box
              marginLeft='44px'
              marginRight='10px'
              display='flex'
              flexDirection='column'
              justifyContent='space-between'
              alignItems='flex-end'>
              <Typography
                variant='body1'
                color='primary'
                fontSize='22px'
                fontWeight='600'
                line-height='25px'>
                {inactiveCount}
              </Typography>
              <Typography
                variant='body1'
                color='black'
                fontSize='22px'
                fontWeight='300'>
                Inactive Associates
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* box 2 */}
        <Box
          flex='0 0 38%'
          display='flex'
          justifyContent='center'
          alignItems='stretch'
          height='35vh'
          marginBottom='10px'>
          {/* box 2, left box  */}
          <Box
            flex='1'
            display='flex'
            justifyContent='center'
            alignItems='stretch'
            height='100%'
            backgroundColor='#F6FAFF'
            marginRight='8px '
            borderRadius='20px'>
            <StackedBarChart
              data={associatesByMonth}
              totalAssociateCount={totalAssociateCount}
            />
          </Box>

          {/* box 2, right box  */}
          <Box
            flex='1'
            display='flex'
            justifyContent='center'
            alignItems='stretch'
            marginLeft='8px'
            backgroundColor='#F6FAFF'
            borderRadius='20px'>
            <DonutChart data={associatesByGrade} />
          </Box>
        </Box>
        {/* box 3  */}
        <Box
          flex='0 0 40%'
          display='flex'
          justifyContent='center'
          alignItems='center'
          height='36vh'>
          <TopAssociates />
        </Box>
        <Footer />
      </Box>
    </Box>
  )
}

export default AdminDashboardScreen
